import builder from '../builder';
import LayoutHeadline from '../../streamline-icons/light/layout-headline.svg';

export default builder('IconLayoutHeadlineLight', LayoutHeadline);
